// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jwqg","col":"styles_col__2zahs"};